import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CareersListPage } from './pages/CareersListPage';
import { CareersJDDetailPage } from './pages/CareersJDDetailPage';
import { CareersApplyPage } from './pages/CareersApplyPage';
import { NotFoundPage } from './pages/NotFoundPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:workspaceCode" element={<CareersListPage />} />
        <Route path="/:workspaceCode/jds/:jdId" element={<CareersJDDetailPage />} />
        <Route path="/:workspaceCode/jds/:jdId/apply" element={<CareersApplyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
